import { withAuthorPanelSwitch, withStandardBaseCssClass } from '@adobe/aem-core-components-react-spa';
import loadable from "../../../utils/loadable";
import withAemIntegration from "../../../withAemIntegration";
import ComponentWrapper from "../../component-wrapper";
import { TabsV1Impl } from './TabsV1.tsx';
import styled from "styled-components";
import React from "react";

const Component = loadable(() =>
    import("@lexus.com/ui/dist/components/ContentTabs/index")
);

const ComponentEditConfig = {
    emptyLabel: "Content Tabs (V2)",
    isEmpty: () => true,
    cqForceReload: true,
};

const Editor = styled.h3`
  text-align: center;
`;

const transformData = (props, childComponents) => {
    const transformed = {
        ...props,
        headline: props?.title,
        fontColor: props?.textColor,
        tabs: [],
        isOverlay: props?.isOverlay || false,
        hasStickyHeader: props?.hasStickyHeader || false,
        tabNavBackground: props?.tabNavBackground || "",
        variant: props?.tabVariant,
        disableSwipe: props?.disableSwipe || false,
    };

    if (childComponents && childComponents.length > 0) {
        childComponents.forEach((child) => {
            // Prefer cq:panelTitle, fallback to title
            const tabName = child?.props?.["cq:panelTitle"] || child?.props?.title || "Tab";
            const tabId = child?.props?.id;
            const renderTabTag = child?.props?.renderTabTag || false;
            const tabTag = child?.props?.tabTag;
            const tabColor = child?.props?.tabColor;

            // modules: if child is an array, use as is, else wrap in array
            let modules = Array.isArray(child) ? child : [child];
            // Extract media, textColumns, ctas if present
            const { media, textColumns, ctas } = child?.props || {};
            const tab = {
                id: tabId || tabName.replace(/\s+/g, "_").toLowerCase(),
                tabName,
                renderTabTag,
                tabTag,
                tabColor,
                modules,
            };
            if (media) {
                tab.media = media;
            }
            if (textColumns) {
                tab.textColumns = textColumns;
            }
            if (ctas) {
                tab.ctas = ctas;
            }
            transformed.tabs.push(tab);
        });
    }

    return transformed;
}

export class ContentTabs extends TabsV1Impl {
    render() {

        const data = transformData(this.props, super.childComponents) ?? {};

        const { editorMode = false } = window;
        if (editorMode) {
            //return (super.render());
            return (
            <Editor>
                <h3>{data?.title}</h3>
                <ComponentWrapper>{super.childComponents}</ComponentWrapper>
                {super.placeholderComponent}
            </Editor>
            );
        } else {
            return (
                <Component {...data}>
                    <ComponentWrapper>{super.childComponents}</ComponentWrapper>
                </Component>
            );
        }
    }
}

export const ContentTabsComponent = withStandardBaseCssClass(withAuthorPanelSwitch(ContentTabs), "cmp-tabs");

export default withAemIntegration(['lexus/components/content/content-tabs'])(
    ContentTabsComponent,
    ComponentEditConfig);
